import { GraphExperience } from "./components/GraphExperience";
import { GraphStatus } from "./components/GraphStatus";
import { useGraphData } from "./hooks/useGraphData";

export default function App() {
  const { data, error, loading, reload } = useGraphData();

  if (loading) return <GraphStatus />;
  if (error || !data) return <GraphStatus error={error} onRetry={reload} />;

  return <GraphExperience data={data} />;
}
